import { graphql } from 'react-relay';

/**
 * The ops "all-green" board query (pv-frontend#32 / pv-mono#70): a top-level
 * deploy-integrity verdict, the per-service roll-up (deploy verdict, live/ready
 * health, running vs shipped version) and the WebFetch definitions currently
 * drifting. Lives in `relay/` (not a screen) so the `graphql` tag stays in a
 * Babel-transformed data module — the screen stays transform-free and testable.
 *
 * The set of services is authoritative from the backend (`SystemStatus:Services`
 * config), so the board is data-driven: an empty list is an honest "nothing
 * monitored", not a bug.
 */
export const systemStatusQuery = graphql`
    query systemStatusQuery {
        systemStatus {
            overall
            services {
                name
                deploy
                health {
                    live
                    ready
                }
                runningVersion
                runningCommit
                shippedVersion
            }
            webFetchDrift {
                definitionId
                name
                total
                ok
                parseEmpty
                parseFailed
                accessBlocked
                status
            }
        }
    }
`;
